import { render } from "./paymentFail.vue?vue&type=template&id=bec82aaa&lang=true"
import script from "./paymentFail.vue?vue&type=script&lang=js"
export * from "./paymentFail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__